export default __webpack_public_path__ + "static/media/background.4823e9e9.jpg";